<template>
  <span>
  <Portlet
      :full-height="true"
      :no-padding="true"
      :headSeparator="true"
      :hasFooter="true"  >

      <template slot="Title"  >
        Track comparison details
      </template>

      <template slot="Options" >
        <template >
          <span></span>
           <Button @click.prevent="onDownloadMissingTracks" >
                <template v-if="!spinner">
                   <span>Download missing tracks</span>
                </template>
                <template v-if="spinner">
                   <span > <i class="fas fa-spinner fa-lg fa-spin"></i> </span>
                </template>
            </Button>
            <UploadMultiSearchButton style="margin-left: 7px"/>
           <span v-tooltip="{ data:  'Download template' , arrowPosition: 'right'}" style="margin-left: 7px">
              <Button @click="download"  download>
                <template>{{  'Download template' }}</template>
              </Button>
            </span>

        </template>
      </template>

      <template slot="Search">
        <span style="line-height: 0.6">&nbsp;</span>
      </template>
      <template slot="PortletNav">

             <ul class="top-sections" style="padding-bottom: 7px">
        <span @click.prevent="toggleLoad('multiSearchDetail')">
            <a :class="[ tableDisplay ==='multiSearchDetail' ? 'btn_active' : 'btn_menu' ]">
                <span>Found Tracks</span>
            </a>
        </span>
        <span @click.prevent="toggleLoad('multiSearchDetailMissing')">
          <a :class="[ tableDisplay !=='multiSearchDetail' ? 'btn_active' : 'btn_menu' ]">
            <span>Missing Tracks</span>
          </a>
        </span>
               <br>
      </ul>
      </template>
    <template slot="Content" >
<div >
        <table class="table table-stripped table-condensed" style="">
            <colgroup>
                <col span="1">
                <col span="3" class="col-l">
                <col class="col-s" />
                <col span="2" class="col-xs" />
                <col span="4" />
                <col duration />
                <col label class="col-l" />
                <col added />
                <col class="actions" />
            </colgroup>
            <thead style="height: 45px ! Important;">
                <tr  >
                    <th role="rowheader">

                        <i  v-if="tableDisplay==='multiSearchDetail'"    :class="['far', selectedFileData.length == 0 ? 'fa-square':'fa-check-square']" @click.prevent="toggleSelection()"></i>
                    </th>
                    <th v-if="tableDisplay ==='multiSearchDetail'">My search</th>
                    <th>Title</th>
                    <th>Artist</th>
                    <th v-if="tableDisplay ==='multiSearchDetail'">Other matches</th>
                    <th>ISRC</th>
                    <th>BPM</th>
                    <th>Year</th>
                    <th>Duration</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="track in fileList"
                    :key="track.uid"
                    :class="[{'selected':selectedFiles.tracks[track.uid]!=null }]" style="line-height: 32px">
                    <th role="rowheader">
                      <span style=" white-space: nowrap;" v-if="tableDisplay==='multiSearchDetail'">
                       <PlayButton class="play-button mr-2" :track="track"></PlayButton>

                            <span :class="['item-bar', {'valid':track.state==Constants.trackStates.VALID.value,'invalid':track.state!=Constants.trackStates.VALID.value}]"></span>
<!--                            <i class="fas fa-play"></i>-->
                            <i @click.prevent="toggleTrack(track, $event)"
                               :class="['far', selectedFiles.tracks[track.uid] === undefined ? 'fa-square':'fa-check-square']"></i>
                        </span>

                    </th>
                    <td v-if="tableDisplay ==='multiSearchDetail'">
                      <span >
                        <span v-if="track.userRequest.Title">Title: {{track.userRequest.Title}} </span> <span v-if="track.userRequest.Artist">-  Artist(s): {{track.userRequest.Artist}}</span><br>
                        <span v-if="track.userRequest.Isrc"> ISRC: {{track.userRequest.Isrc}} </span> <span v-if="track.userRequest.Duration">-  Duration: {{track.userRequest.Duration}} </span> <span v-if="track.userRequest.Release">-  Year: {{track.userRequest.Release}}</span>
                      </span>
                    </td>
                    <td>
                       {{track.title}}
                    </td>
                    <td>
                       {{track.artist}}
                    </td>
                     <td v-if="tableDisplay ==='multiSearchDetail'">
                         <span v-if="track.otherTrackCount > 0">
                           <span @click.prevent="openOtherTracks(track)" class="otherTrack">
                             {{track.otherTrackCount}}
                            <span v-if="track.otherTrackCount > 1"> Matches </span>
                             <span v-if="track.otherTrackCount === 1"> Match </span>

                           </span>
                         </span>


                    </td>
                     <td>
                       {{track.isrc}}
                    </td>
                    <td>
                       {{track.bpm}}
                    </td>
                    <td>
                        {{track.year}}
                    </td>
                    <td>
                        <DurationText :duration="track.duration"></DurationText>
                    </td>
                  <td><i class="fas fa-window-close"
                         v-if="tableDisplay ==='multiSearchDetail'"
                         style="color: #EA8F34"
                         v-tooltip="{ data:  'Rejection' , arrowPosition: 'right'}"
                         @click.prevent="rejection(track)"
                  ></i></td>
                </tr>
            </tbody>
            <tfoot v-show="selectedFileData.length>1">

            </tfoot>
        </table>

    </div>

        <div

            class="table-footer"
            v-show="hasFixedFooter"
        >
    <div class="table-footer-left">
      <a href="#" class="table-footer-button" v-on:click.prevent="removeAllSelectedTracks">
        <i class="fas fa-times fas-xl"></i>
      </a>

      <span class="table-footer-text">
<!--            <span class="table-footer-count">{{selectedFiles.tracks }}</span>-->
<!--            tracks selected-->
        </span>
    </div>
    <div :class="['table-footer-right', hasSelectedTrack?'active':'']">

      <span v-if="uploadLocked">
            <a href="#" :class="['table-footer-button', 'cursor-not-allowed']"  :disabled="hasSelectedTrack" v-tooltip="{data: uploadLocked ? stationLockDescriptionShort : 'Move files' , arrowPosition: 'right'}">
            <i  :class="['fas', 'fa-file-export','fas-l']"
            ></i>
          </a>

          </span>

      <span v-if="!uploadLocked">
            <a href="#" :class="['table-footer-button', ]"  :disabled="hasSelectedTrack" v-tooltip="{data: uploadLocked ? stationLockDescriptionShort : 'Move files' , arrowPosition: 'right'}">
            <i  :class="['fas', 'fa-file-export','fas-l']"
                @click.prevent="multiAction('move')"  ></i>
            </a>
          </span>
        <span v-if="!uploadLocked">
            <a href="#" :class="['table-footer-button', ]"  :disabled="hasSelectedTrack" v-tooltip="{data: uploadLocked ? stationLockDescriptionShort : 'Move files' , arrowPosition: 'right'}">

            <i class="fas fa-window-close"
               style="color: red"

               v-tooltip="{ data:  'Rejection' , arrowPosition: 'right'}"
               @click.prevent="rejection()"
            ></i>
              </a>
          </span>

    </div>
   </div>

    </template>

    <template slot="">

    </template>

  </Portlet>
     <SelectorBoxes
         v-show="false"
         ref="modalBoxes"
         :stationUid="currentStationUid"
         :noModalEdit="true"
         v-on:newValue="linkToBoxes"
     />
      <OtherTracks
          :empty="true"
          ref="otherTracks"
          :stationUid="currentStationUid"
          :multiSearchUid="multiSearchUid"
          :currentTrack="currentTrack"
          :itemId="itemId"
          :noModalEdit="true"
          @confirmed="loadData"
          v-on:newValue="ChangeTrack"/>
</span>

</template>

<script>
import Portlet from "@/components/common/Portlet";
import router from "@/router";
import store from "@/store";
import {HTTP} from "@/utils/http";
import Apis from "@/apis";
import moment from "moment";
import UploadMultiSearchButton from "@/components/Library/UploadMultiSearchButton.vue";
import TrackRemovalCard from "@/components/Library/TrackRemovalCard.vue";
import LanguageBadgeList from "@/components/common/LanguageBadgeList.vue";
import LabelTextInput from "@/components/common/LabelTextInput.vue";
import DurationText from "@/components/common/DurationText.vue";
import StyleBadgeList from "@/components/common/StyleBadgeList.vue";
import MultiChoiceTextInput from "@/components/common/MultiChoiceTextInput.vue";
import NumberInput from "@/components/common/NumberInput.vue";
import TextInput from "@/components/common/TextInput.vue";
import ArtistBadgeList from "@/components/common/ArtistBadgeList.vue";
import Constants from "@/store/constants";
import Translations from "@/store/translations";
import Axios from "axios";
import SelectorBoxes from "@/components/Library/SelectorBoxes.vue";
import Vue from "vue";
import EventBus from "@/eventbus";
import PlayButton from "@/components/common/PlayButton.vue";
import Tracks from "@/router/sections/tracks";
import OtherTracks from "@/components/Report/OtherTracks.vue";
export default {
  name: "MasterMultiSearchSimpleSection",
  router,
  store,
  components: {
    Tracks,
    PlayButton,
    OtherTracks,
    SelectorBoxes,
    ArtistBadgeList,
    TextInput,
    NumberInput,
    MultiChoiceTextInput,
    StyleBadgeList,
    DurationText,
    LabelTextInput,
    LanguageBadgeList,
    TrackRemovalCard,
    Portlet,UploadMultiSearchButton

  },

  created(){
    this.spinner = false;
  },
  beforeDestroy(){},

  data() {
    return {
      stationLockDescriptionShort: Constants.stationLockedLabelShort,
      stationLockDescription: Constants.stationLockedLabel,
      uploadData: null,
      multiSearchUid: null,
      itemId: null,
      currentTrack: null,
      errorMessage: false,
      editMode:false,
      uploadLocked: false,
      tableDisplay :'multiSearchDetail',
      moment,
      selectedFiles: {
        tracks: {},
        updateTime: new Date()
      },
      fileList: null,
      fileListMissing: null,
      spinner: false,
    }
  },

  computed: {
    Constants: () => Constants,
    maxYear: () => new Date().getFullYear(),
    currentStationUid: () => store.state.currentStationUid,
    Translations: function () { return Translations; },
    selectedFileData: function () {
      return {
        length: Object.keys(this.selectedFiles.tracks).length,
        tracks: Object.values(this.selectedFiles.tracks),
        // trackUids: Object.keys(this.selectedFiles.tracks) || []
      };
    },
    selectedTracks () {
      return Object.values(this.selectedFiles.tracks)
    },
    hasFixedFooter () {
      return this.selectedTracks.length > 0;
    },
  },
  mounted() {
    this.toggleLoad();
  },
  methods: {
    ChangeTrack(){

    },
    openOtherTracks(track) {
      console.log('openOtherTracks')
      if(track.otherTrackCount > 0){
        if (!this.$refs.otherTracks) return;
        this.multiSearchUid =location.pathname.split('/')[3]
        this.itemId =track.itemId
        this.currentTrack =track
        console.log(this.multiSearchUid,this.itemId ,this.currentTrack )
        this.$refs.otherTracks.show({multiSearchUid: this.multiSearchUid , itemId:this.itemId , currentTrack :this.currentTrack});
      }

    },
    rejection(track){
     // this.boxTwo = ''
      this.$bvModal.msgBoxConfirm('Are you sure you want to reject this track and move it to Missing Tracks?', {
        title: 'Confirmation',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'outline-warning',
        okTitle: 'Ok',
        cancelTitle: 'Cancel',
        cancelVariant: 'light',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      })
          .then(value => {
            if(value){


            var files
            if(track){
              files =[track.itemId]
            }

            if(!track){
              files = Object.keys(this.selectedFiles.tracks).map(
                  prop => this.selectedFiles.tracks[prop].itemId
              );

            }
            console.log(track)
            HTTP.post("/api/multi-search/reject" ,
                {
                  MultiSearchUid:  location.pathname.split('/')[3],
                  RadioUid: location.pathname.split('/')[1],
                  ItemIds:files
                })
                .then(response => {
                  if(response.status === 200){
                    this.loadData();
                    this.makeToast('Reject success', 'success' ,'Success')
                  } else{
                    this.makeToast('Failed to generate zip', 'danger' ,'Error')
                  }
                }).catch(error => {
              this.spinner = false;
            })
            }
          })
          .catch(err => {
            // An error occurred
          })

    },
    makeToast(msg , type , title) {
      this.$store.dispatch('Toasts/addToast', {
        title: title,
        message: msg,
        type: type
      });
    },
    toggleLoad(event){
      this.fileList= [];
      if(event){
        this.tableDisplay = event;
      }
      if(this.tableDisplay === 'multiSearchDetail'){
        this.loadData();
      }else{
        this.loadDataMissing();
      }
    },
    toggleTrack(track, event) {
      track.isSelected = !track.isSelected;
      if (this.selectedFiles.tracks[track.uid] != null) {
        Vue.delete(this.selectedFiles.tracks, track.uid);
      } else {
        this.$set(this.selectedFiles.tracks, track.uid, track)
      }
    },
    // REVIEWED
    async linkToBoxes(type, targetBoxes)
    {
      for(var idx in targetBoxes)
      {
        let box = targetBoxes[idx];
        await this.$store.dispatch("Boxes/linkMultipleTrack",
            {
              stationUid: box.stationUid,
              boxUid: box.uid,
              trackUids:Object.keys(this.selectedFiles.tracks)
            })
        await this.refreshBoxStats(box.stationUid,box.uid)
      }
    },
    multiAction(code)
    {

      if (!this.hasSelectedTrack) return false;
      switch(code){
        case"move": this.moveFiles ("selected");break;
      }
    },
    moveFiles(tracks) {
      let files = tracks;

      if (tracks === "selected") {
        files = Object.keys(this.selectedFiles.tracks).map(
            prop => this.selectedFiles.tracks[prop]
        );
      }
      //this.$refs.moveTracks.show(files);
      this.$refs.modalBoxes.show(files);
    },
    hasSelectedTrack(){
      return Object.keys(this.selectedFiles.tracks).length > 0;
    },
    toggleSelection: function() {
      if (this.selectedFileData.length === 0) {
        let selection = {};
        this.fileList.forEach(tr => {
          selection[tr.uid] = tr;
        });
        this.selectedFiles.tracks = selection;
      } else {
        this.selectedFiles.tracks = {};
      }
    },
    onDragStart(e, track) {
      if(Object.keys(this.selectedFiles.tracks).length == 0)
      {
        e.preventDefault();
        return;
      }
      // Fix for Firefox
      e.dataTransfer.setData("text/html", "");
      const tracks = [];
      const $ghost = document.body.querySelector("#drag-ghost");

      if (
          (this.selectedFiles.tracks[track.uid] != null &&
              this.selectedTracks.length > 1) ||
          track === "selection"
      ) {
        $ghost.innerHTML = `${this.selectedTracks.length} files selected`;
        tracks = this.selectedTracks
      } else {
        $ghost.innerHTML = track.title;
        tracks.push(track);
      }

      this.$store.dispatch("dnd/update", { type: "tracks", item: tracks });
      e.dataTransfer.setDragImage($ghost, 0, 0);
      EventBus.$emit("dragStart");
    },
    onDragEnd(e) {
      EventBus.$emit("dragEnd");
    },
    loadDataMissing(){
      this.multiSearchUid = location.pathname.split('/')[3];
      HTTP.get("/api/multi-search/"+this.multiSearchUid+"/missing-tracks")
          .then(({ data }) => {
            this.errorMessage = false;
            this.uploadData = data.dataItem
            this.fileList= [];
            var track;
            for (let i = 0; i < this.uploadData.items.length; i++) {
              track = {};
                track.userRequest = JSON.parse(this.uploadData.items[i].userRequest)
                track.otherTrackCount = this.uploadData.items[i].otherTrackCount
                track.title = track.userRequest.Title
                track.id = this.uploadData.items[i].trackId
                track.itemId = this.uploadData.items[i].id
                track.duration = track.userRequest.Duration
                track.isrc = track.userRequest.Isrc
                track.year = track.userRequest.Release
                track.artist = track.userRequest.Artist
                track.description = track.userRequest.Url
                this.fileList.push(
                    track
                );
            }
          })
          .catch(error => {

            this.errorMessage = true;
            console.log('-------------')
            console.log('error', error)
          })

    },
    loadData(){
      HTTP.get('api/multi-search/'+this.$route.params.id+'/details')
          .then(({ data }) => {
            this.errorMessage = false;
            this.uploadData = data.dataItem
            this.fileList= [];
            var track;
            for (let i = 0; i < this.uploadData.items.length; i++) {
              if(this.uploadData.items[i].found === true){
                track = this.uploadData.items[i].track;
                track.userRequest = JSON.parse(this.uploadData.items[i].userRequest)
                track.otherTrackCount = this.uploadData.items[i].otherTrackCount
                track.itemId = this.uploadData.items[i].id
                this.fileList.push(
                    track
                );
              }

            }
            console.log('----------------------------------------------------------------------------------------------')
            console.log( this.fileList)
          })
          .catch(error => {

            this.errorMessage = true;
            console.log('-------------')
            console.log('error', error)
          })

    },
    download () {
      const url = '/Template multi search.csv';
      // window.location.href = url;
      Axios.get(url, { responseType: 'blob' })
          .then(response => {
            const blob = new Blob([response.data], { type: 'text/csv' })
            const link = document.createElement('a')
            link.href = URL.createObjectURL(blob)
            link.download = 'Template'
            link.click()
            URL.revokeObjectURL(link.href)
          }).catch(console.error)
    },
    updateSpinner() {
      console.log('updateSpinner', this.spinner)
      this.spinner = false;
    },
    onDownloadMissingTracks() {
      if(this.spinner === false) {
        this.spinner = true;
        HTTP.get("/api/multi-search/"+location.pathname.split('/')[3]+"/missing-tracks-file")
            .then(response => {
              console.log(response);
              const url = window.URL.createObjectURL(new Blob([response.data]));
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute("download", "missing-tracks-file.csv");
              document.body.appendChild(link);
              link.click();
              link.parentNode.removeChild(link);
            }).then(this.updateSpinner).catch(this.updateSpinner);
      }

    },
    removeAllSelectedTracks() {
      this.selectedFiles.tracks = {};
    },
  },
  watch: {}
};
</script>

<style lang="scss" scoped>
.back-button {
  margin-right: 20px;
  align-self: center;

  i {
    padding: 0;
    font-size: 14px;
  }
}

.title-text {
  align-self: center;
}

// Search
.portlet-search {
  display: flex;
  align-items: center;
justify-content: flex-end;
  .fa-search {
    margin-right: 20px;
    color: var(--COLOR_BRAND);
  }

  .portlet-search-advanced {
    border: 0;
    background-color: transparent;
    margin-left: 20px;
    font-size: 11px;
    font-weight: 600;
    padding: 9px 15px;
    letter-spacing: 0.7px;
    text-transform: uppercase;

    &:hover {
      text-decoration: none;
    }
  }

  .portlet-search-input {
    flex-grow: 1;
    font-size: 14px;
    letter-spacing: 0.2px;
    line-height: 17px;
    color: var(--COLOR_TEXT);
    border-bottom: 1px solid var(--COLOR_BRAND);

    &[value=""] {
      border-bottom: 1px solid var(--COLOR_LIGHT);
    }
    &:focus {
      border-bottom: 1px solid var(--COLOR_BRAND);
    }
  }

  .portlet-search-submit {
    margin-left: 5px;
    text-transform: uppercase;
  }

  .portlet-search-close {

    i {
      transition: color 0.2s ease-in-out;
      font-size: 20px;
    }

    &:not(:hover) {
      i {
        color: #d2d2d2;
      }
    }
  }
}
table {
  width: 100%;
  max-height: 100%;
  margin-bottom: 0;

  &.is-sorting {
    tbody {
      opacity: 0.5;
      pointer-events: none;
    }
  }
}

thead {
  position: -webkit-sticky;
  /* Safari */
  position: sticky;
  z-index: 1000;
  top: 0;
  background: white; // border-bottom: 2px solid #d2d2d2;

  th {
    border-bottom: 0;

    &::after {
      content: "";
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
      height: 1px;
      background-color: #d2d2d2;
    }
  }
}

tbody {
  background-color: #fff;
  tr.shiftable {
    td, th {
      border-bottom:1px solid var(--COLOR_BRAND) !important;
    }
    border-bottom:1px solid var(--COLOR_BRAND) !important;
  }
  tr:first-child th,
  tr:first-child td {
    border-top: 0;
  }
}

tfoot tr,
tfoot tr th,
tfoot tr td {
  vertical-align: middle;
  border-top: 1px solid #d2d2d2;
}

thead tr,
thead tr th,
tfoot tr {
  font-size: 13px;
  line-height: 16px;
}

tfoot {
  font-weight: bold;
}

td {
  padding: 0 12px;
  /* Keep it : to have more data lines on screen */
  vertical-align: middle;

  &:not(:last-child) {
    border-right: 1px dashed #d2d2d2;
  }

  &.td-m {
    min-width: 80px;
  }

  &.td-xl {
    min-width: 120px;
  }

  &.td-actions {
    &:hover {
      z-index: 801;
    }

    .td-actions-wrapper {
      display: flex;

      > *:not(:first-child) {
        margin-left: 8px;
      }
    }

    a {
      transition: opacity 0.15s ease-in-out;
      opacity: 0.5;

      &:hover {
        opacity: 1;
      }
    }

    i {
      &.fa-exclamation-triangle {
        color: #fe6b5b;
      }
      &.fa-check {
        color: #89c42c;
      }
    }

    .filled {
      position: relative;

      .filled-toggle {
        &:hover {
          & + .filled-dropdown {
            display: block;
          }
        }
      }

      .filled-dropdown {
        display: none;
        position: absolute;
        top: calc(100% + 5px);
        right: 0;
        width: 300px;
        padding: 10px 15px 17px;
        border-radius: 5px;
        box-shadow: 0 1px 21px 2px rgba(0, 0, 0, 0.2);
        background-color: #fff;
        font-size: 14px;
        line-height: 1.2;

        span {
          white-space: normal;
        }

        i {
          display: inline-block;
          opacity: 1;
          margin-right: 2px;
          margin-bottom: -15px;
        }

        // Extend hover surface
        &::after {
          content: "";
          position: absolute;
          top: -12px;
          left: 0;
          width: 100%;
          height: 13px;
        }

        &:hover {
          display: block;
        }
      }
    }
  }
}

tr {
  font-size: 14px;
  .fa-play {
    color: transparent;
  }
}

tr:hover .fa-play {
  color: #aaaaaa;
}

thead th,
tbody th {
  vertical-align: middle;
  color: #aaaaaa;
  font-size: 13px;
  line-height: 16px;
}

thead th {
  border-top: 0;
  padding-top: 15px;

  &:not(:first-child):not(:last-child) {
    color: #292c33;
  }

  .sort {
    display: flex;
    cursor: pointer;
    transition: color 0.15s ease-in-out;
    color: #aaaaaa;
    font-weight: 400;

    &[disabled] {
      pointer-events: none;
    }

    &.is-active {
      color: #000;
    }

    &:hover {
      text-decoration: none;
    }

    &-icons {
      display: flex;
      flex-direction: column;
      position: relative;
      margin-left: 5px;

      i {
        font-size: 10px;
        height: 8px;
      }
    }

    @keyframes sorting {
      0% {
        transform: rotate(0);
      }
      100% {
        transform: rotate(360deg);
      }
    }

    .fa-sync-alt {
      align-self: center;
      font-size: 12px;
      margin-left: 5px;
      transform-origin: 50% 50%;
      animation: sorting 1s linear infinite;
    }
  }
}

thead th:first-child,
tbody th:first-child {
  text-align: right;
  background: white;
  vertical-align: middle;
  position: -webkit-sticky;
  /* Safari */
  position: sticky;
  left: 0;
  z-index: 800; // padding-left: 0px;

  &::before {
    content: "";
    position: absolute;
    right: 0;
    top: 0;
    width: 1px;
    height: 100%;
    background-color: #d2d2d2;
  }
}

thead th:first-child {
  z-index: 1600;
}

thead th:last-child,
tbody td:last-child {
  max-height: 100%;
  vertical-align: middle;
  position: -webkit-sticky;
  /* Safari */
  position: sticky;
  right: 0;
  z-index: 800;
  background: #fff;

  &::before {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    width: 1px;
    height: 100%;
    background-color: #d2d2d2;
  }
}

thead th:last-child,
tfoot th:last-child {
  position: sticky;
  right: 0;
  z-index: 1600;
}

thead th[role="rowheader"] i,
tbody td:last-child i,
tbody th[role="rowheader"] i {
  line-height: 30px;
  display: inline;
  padding: 10px;
  cursor: pointer;
}

thead th:last-child {
  background: white;
}

tbody tr[role="rowheader"] i,
tbody td:last-child a {
  text-decoration: none;
}

td input[type="text"] {
  width: calc(100% - 20px);
  font-size: 1rem;
  line-height: 1.5;
  color: #495057;
  background-color: transparent;
  background-clip: padding-box;
  outline: none;
  &:focus {
    background-color: rgba(#fff, 0) !important;
    border-bottom: 1px solid;
  }
}

col.col-l {
  min-width: 20em;
}

col.col-s {
  min-width: 10em;
}

col.col-xs {
  width: 5em;
}

col.actions {
  background: #495057;
}
.label-warning {
  background-color: #f0ad4e;
  color:#ffffff;
  padding:5px;border-radius: 7px ;margin-right: 3px
}
.label-info {
  background-color: #5cb85c;
  color:#ffffff;
  padding:5px;border-radius: 7px ;margin-right: 3px
}
.label-danger{
  background-color:#d9534f;
  color:#ffffff;
  padding:5px;border-radius: 7px ;margin-right: 3px
}
.sort {
  display: flex;
  cursor: pointer;
  transition: color 0.15s ease-in-out;
  color: #aaaaaa;
  font-weight: 400;

  &[disabled] {
    pointer-events: none;
  }

  &.is-active {
    color: #000;
  }

  &:hover {
    text-decoration: none;
  }

  &-icons {
    display: flex;
    flex-direction: column;
    position: relative;
    margin-left: 5px;

    i {
      font-size: 10px;
      height: 8px;
    }
  }

  @keyframes sorting {
    0% {
      transform: rotate(0);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  .fa-sync-alt {
    align-self: center;
    font-size: 12px;
    margin-left: 5px;
    transform-origin: 50% 50%;
    animation: sorting 1s linear infinite;
  }
}
.sort {
  display: flex;
  cursor: pointer;
  transition: color 0.15s ease-in-out;
  color: #aaaaaa;
  font-weight: 400;

  &[disabled] {
    pointer-events: none;
  }

  &.is-active {
    color: #000;
  }

  &:hover {
    text-decoration: none;
  }

  &-icons {
    display: flex;
    flex-direction: column;
    position: relative;
    margin-left: 5px;

    i {
      font-size: 10px;
      height: 8px;
    }
  }

  @keyframes sorting {
    0% {
      transform: rotate(0);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  .fa-sync-alt {
    align-self: center;
    font-size: 12px;
    margin-left: 5px;
    transform-origin: 50% 50%;
    animation: sorting 1s linear infinite;
  }
}
div.menu-expanded{
  .table-footer{
    position: relative;
    left: 0px;
    transition: all .5s ease-in-out;
  }
}
.table-footer {
  position: sticky;
  height: 45px;
  left: 10px;
  bottom: 0;
  display: flex;
  justify-content: space-between;
  z-index: 1200;
  right: 10px;
  align-items: center;
  transition: all .5s ease-in-out;
  .td {
    flex-shrink: 0;
    padding: 16px 12px;
    vertical-align: middle;
    color: #fff;
    &:first-child {
      padding-left: 15px;
    }
    &:last-child {
      display: flex;
      min-width: 142px;
      padding-left: 22px;
      a + a {
        margin-left: 20px;
      }
    }
    button.option {
      color: #fff;
    }

  }
  .fas {
    &.fas-l {
      font-size: 18px;
    }
    &.fas-xl {
      font-size: 24px;
    }
  }
}

.table-footer-left,
.table-footer-right {
  display: flex;
  align-items: center;
  padding: 0 15px;
  color: #fff;
  .fas {
    display: block;
  }
}

.table-footer-right {
  position: absolute;
  right: -300px;
  transition:all 0.5s ease-in-out;
  &.active {
    right:0;
    background: transparent;
    transition:all 0.5s ease-in-out;
  }
  .table-footer-button {
    margin-left: 20px;
  }
}

.table-footer-text {
  color: #fff;
  font-size: 14px;
  font-weight: bold;
  line-height: 19px;
}

.table-footer-count {
  display: inline-block;
  padding: 2px 10px 4px;
  margin-right: 4px;
  border-radius: 20px;
  background-color: rgba(#000, 0.2);
}

.table-footer-button {
  display: inline-block;
  transition: opacity 0.2s ease-in-out;
  color: #fff;
  text-decoration: none;
  cursor: pointer;
  vertical-align: middle;
  &:hover {
    opacity: 0.6;
  }
  + .table-footer-text {
    margin-left: 23px;
  }
}
.description {
  display: block;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  width: 200px;
}
.track-list__root{
  position: relative;

  .pagination__root{
    position: fixed;
    bottom: 70px;
    left: 50%;
    transform: translateX(0);
    border-radius: 0.25rem;
    max-width: unset;
  }
}
.b-pagination li {
  padding: 0;
  a{
    border-top: none;
    border-bottom: none;
  }
  a, span{
    height: 100%;
  }
  &.active {
    a{
      border-color: #dee2e6;
    }
  }
}

.pointer-events-none {
  pointer-events: none;
}
.cursor-not-allowed {
  cursor : not-allowed;
}
.tag{
  padding:5px;border-radius: 7px ;margin-right: 3px
}
ul.top-sections{
  display: flex;
  li {
    margin-right:15px;

    &.router-link-active
    {
      position:relative;
      a{
        color:#212529;
      }
      &::after {
        background-color: #ff6a00;
        content: '';
        position: absolute;
        top: 100%;
        left: 0;
        width: 100%;
        height: 3px;
      }
    }
  }
}
.btn_menu {
  color: #8c8c8c!important;
  font-size:17px ;
  font-weight: 600;
  font-family: "Proxima Nova", "Helvetica Neue", Helvetica, Arial, sans-serif;

  &:hover{
    color: #EA8F34!important;
    cursor: grab;
  }
}
.btn_active{
  color: #292c33 !important;
  font-weight: 600;
  font-family: "Proxima Nova", "Helvetica Neue", Helvetica, Arial, sans-serif;
  border-bottom: 3px solid #EA8F34;
  padding-bottom: 9px;
}
.outline-warning{
  &:hover {
    background-color: #EA8F34;
  }
}
.otherTrack{
  &:hover {
    color: black;
    border-bottom: 2px solid black;
  }
}
</style>
